// extracted by mini-css-extract-plugin
module.exports = {"reviewContent":"Review_reviewContent__3D6w2","reviewStars":"Review_reviewStars__2zctC","reviewStar":"Review_reviewStar__1jTUZ"};